import { html } from 'htm/preact';

const ProgressBar = ({ step, count }) => {
  const roundedStep = Math.floor(step);
  const progress = (roundedStep / count) * 100;

  return html`
    <div class="flex gap-3 w-full">
      <div class="grow bg-white rounded-4xl flex relative justify-center items-center border-4 border-white">
        <div
          class="flex justify-end absolute bg-yellow rounded-4xl left-0 inset-y-0 w-full transition-all"
          style="max-width: ${Math.round(progress)}%"
        ></div>
        <div class="h6 normal-case relative">
          ${roundedStep === count ? 'Finished!' : `Step ${roundedStep} of ${count}`}
        </div>
      </div>
    </div>
  `;
};

export default ProgressBar;
